import React, { useEffect, useState } from "react";
import { Form, Select, Table, Input, Row, Col } from "antd";
import { getDietApi } from "../../../../services/diet.services";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import {
  getLabelTagInput,
  getLabelTagsWithChecklistLables,
} from "../../../IpEMR/InspectionSummaries/constructTextFromValues";
import { otherSpecificationsOptions } from "../../../IpEMR/Options/dietAdviceOptions";

const DietTable = ({
  data,
  onChange,
  mapToCustomTag,
  overAllCalc,
  dietDetails,
}) => {
  const dietType = dietDetails?.dietType ?? dietDetails?.ia?.dietType;

  const [tableData, setTableData] = useState(data);
  const [items, setItems] = useState([]);

  useEffect(() => {
    getDietApi(`patination=no_pagination`)
      .then((res) => setItems(res?.data?.data))
      .catch((err) => console.log(err));
  }, []);

  // Handle changes to selected items in the table
  const handleItemChange = (selectedItems, record) => {
    const totalValues = selectedItems.reduce(
      (totals, itemName) => {
        const item = items.find((dietItem) => dietItem.id === itemName);
        if (item) {
          totals.proteins += item.protien || 0;
          totals.calories += item.calories || 0;
          totals.sodium += item.sodium || 0;
          totals.potassium += item.potassium || 0;
          totals.carbohydrate += item.carbohydrates || 0;
        }
        return totals;
      },
      { proteins: 0, calories: 0, sodium: 0, potassium: 0, carbohydrate: 0 }
    );

    const updatedData = tableData.map((data) =>
      data.time === record.time
        ? { ...data, items: selectedItems, ...totalValues, modified: true }
        : data
    );

    setTableData(updatedData);
    onChange(updatedData); // Notify parent component of the change
  };

  const columns = [
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      width: 80,
      render: (text) => (
        <span>
          {text >= 12
            ? `${text > 12 ? text - 12 : text}:00 PM`
            : `${text}:00 AM`}
        </span>
      ),
    },
    {
      title: "Items",
      dataIndex: "items",
      key: "items",
      width: 300,
      render: (text, record) => (
        <Form.Item name={[record.time, "items"]}>
          <Select
            className={inputStyles.mdSelect}
            style={{ width: "100%" }}
            mode="multiple"
            showSearch // Enables searching within the Select component
            optionFilterProp="children" // Filters based on the option text
            onChange={(selectedItems) =>
              handleItemChange(selectedItems, record)
            }
            disabled={!dietType}
          >
            {items?.map((item) => (
              <Select.Option key={item?.id} value={item?.id}>
                {item?.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      ),
    },
    { title: "Proteins", dataIndex: "proteins", key: "proteins", width: 80 },
    { title: "Energy", dataIndex: "calories", key: "calories", width: 80 },

    {
      title: "Carbohydrate",
      dataIndex: "carbohydrate",
      key: "carbohydrate",
      width: 80,
    },
    { title: "Sodium", dataIndex: "sodium", key: "sodium", width: 80 },
    {
      title: "Potassium",
      dataIndex: "potassium",
      key: "potassium",
      width: 80,
    },

    {
      title: "Comment",
      dataIndex: "comment",
      key: "comment",
      width: 80,
      render: (_, record) => (
        <Form.Item name={[record.time, "comments"]}>
          <Input.TextArea
            className={inputStyles.mdInput}
            rows={1}
            disabled={!dietType}
          />
        </Form.Item>
      ),
    },
  ];

  const filterOnDietType = (data) => {
    if ((dietDetails?.dietType ?? dietDetails?.ia?.dietType) === "Oral") {
      return Object.fromEntries(
        Object.entries(data).filter(([key]) =>
          ["proteins", "protein", "calories"].includes(key)
        )
      );
    }
    return data;
  };

  return (
    <Table
      title={() => (
        <>
          <Row gutter={[0, 4]}>
            <Col span={24}>
              Diet Plan{" "}
              {mapToCustomTag(filterOnDietType(overAllCalc), "purple")}
            </Col>
            <Col span={24}>
              Required{" "}
              {mapToCustomTag(
                filterOnDietType(
                  dietDetails?.nutritional_recommendations ??
                    dietDetails?.ia?.nutritional_recommendations ??
                    {}
                ),
                "purple"
              )}
            </Col>
            <Col span={24}>
              {getLabelTagInput(
                "Diet Type",
                dietDetails?.dietType ?? dietDetails?.ia?.dietType
              )}
              {getLabelTagsWithChecklistLables(
                otherSpecificationsOptions,
                dietDetails?.otherSpecifications ??
                  dietDetails?.ia?.otherSpecifications
                // true,
                // "purple"
              )}
            </Col>
            {/* {dietType ? <Space>Diet Type: {dietType}</Space> : null} */}
          </Row>
        </>
      )}
      dataSource={tableData}
      columns={columns}
      pagination={false}
      rowKey="time"
      style={{ background: "#fff" }}
      scroll={{ y: "calc(100vh - 330px)", x: "1400px" }}
    />
  );
};

export default DietTable;
